import mkReduxActionApiRequest from 'scripts/util/redux/mkReduxActionApiRequest'

export const LOAD_FILTER_CHOICES =
  'ksk001/estateFilterChoices/LOAD_FILTER_CHOICES'
export const LOAD_FILTER_CHOICES_SUCCESS =
  'ksk001/estateFilterChoices/LOAD_FILTER_CHOICES_SUCCESS'
export const LOAD_FILTER_CHOICES_FAILURE =
  'ksk001/estateFilterChoices/LOAD_FILTER_CHOICES_FAILURE'

export const initialState = {
  choices: {
    perimeter: [1, 2, 3, 4, 5, 10, 20, 30, 50],
    objektart: [],
  },
  error: null,
  isLoading: false,
  isLoaded: false,
}

export default (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case LOAD_FILTER_CHOICES:
      return {
        ...state,
        isLoading: true,
      }
    case LOAD_FILTER_CHOICES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        choices: { ...state.choices, ...payload },
      }
    case LOAD_FILTER_CHOICES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      }
    default:
      return state
  }
}

export const loadFilterChoices = () => (dispatch, getState) => {
  const state = getState()
  const isLoaded = state.estateFilterChoices.isLoaded

  if (isLoaded) {
    return
  }

  return mkReduxActionApiRequest({
    apiFetchArgs: { path: '/dhsv/v1/estate-filters/choices' },
    types: {
      initial: LOAD_FILTER_CHOICES,
      success: LOAD_FILTER_CHOICES_SUCCESS,
      failure: LOAD_FILTER_CHOICES_FAILURE,
    },
    dispatch,
  })
}
